const Bancos =[
  {'id':'1', 'title':'Banco ABC Brasil S.A.'},
  {'id':'2', 'title':'Banco ABN AMRO Real S.A.'},
  {'id':'3', 'title':'Banco Alfa S.A.'},
  {'id':'4', 'title':'Banco Alvorada S.A.'},
  {'id':'5', 'title':'Banco Banerj S.A.'},
  {'id':'6', 'title':'Banco Banestado S.A.'},
  {'id':'7', 'title':'Banco Barclays S.A.'},
  {'id':'8', 'title':'Banco BBM S.A.'},
  {'id':'9', 'title':'Banco Beg S.A.'},
  {'id':'10', 'title':'Banco Bem S.A.'},
  {'id':'11', 'title':'Banco BM&F de Serviços de Liquidação e Custódia S.A'},
  {'id':'12', 'title':'Banco BMC S.A.'},
  {'id':'13', 'title':'Banco BMG S.A.'},
  {'id':'14', 'title':'Banco BNP Paribas Brasil S.A.'},
  {'id':'15', 'title':'Banco Boavista Interatlântico S.A.'},
  {'id':'16', 'title':'Banco Bradesco S.A.'},
  {'id':'17', 'title':'Banco Brascan S.A.'},
  {'id':'18', 'title':'Banco Cacique S.A.'},
  {'id':'19', 'title':'Banco Calyon Brasil S.A.'},
  {'id':'20', 'title':'Banco Cargill S.A.'},
  {'id':'21', 'title':'Banco Citibank S.A.'},
  {'id':'22', 'title':'Banco Comercial e de Investimento Sudameris S.A.'},
  {'id':'23', 'title':'Banco Cooperativo do Brasil S.A. – BANCOOB'},
  {'id':'24', 'title':'Banco Cooperativo Sicredi S.A. – BANSICREDI'},
  {'id':'25', 'title':'Banco Credit Suisse (Brasil) S.A.'},
  {'id':'26', 'title':'Banco Cruzeiro do Sul S.A.'},
  {'id':'27', 'title':'Banco da Amazônia S.A.'},
  {'id':'28', 'title':'Banco Daycoval S.A.'},
  {'id':'29', 'title':'Banco de Pernambuco S.A. – BANDEPE'},
  {'id':'30', 'title':'Banco de Tokyo-Mitsubishi UFJ Brasil S.A.'},
  {'id':'31', 'title':'Banco Dibens S.A.'},
  {'id':'32', 'title':'Banco do Brasil S.A.'},
  {'id':'33', 'title':'Banco do Estado de Santa Catarina S.A.'},
  {'id':'34', 'title':'Banco do Estado de Sergipe S.A.'},
  {'id':'35', 'title':'Banco do Estado do Pará S.A.'},
  {'id':'36', 'title':'Banco do Estado do Rio Grande do Sul S.A.'},
  {'id':'37', 'title':'Banco do Nordeste do Brasil S.A.'},
  {'id':'38', 'title':'Banco Fator S.A.'},
  {'id':'39', 'title':'Banco Fibra S.A.'},
  {'id':'40', 'title':'Banco Finasa S.A.'},
  {'id':'41', 'title':'Banco Fininvest S.A.'},
  {'id':'42', 'title':'Banco GE Capital S.A.'},
  {'id':'43', 'title':'Banco Gerdau S.A.'},
  {'id':'44', 'title':'Banco Guanabara S.A.'},
  {'id':'45', 'title':'Banco Ibi S.A. Banco Múltiplo'},
  {'id':'46', 'title':'Banco Industrial do Brasil S.A.'},
  {'id':'47', 'title':'Banco Industrial e Comercial S.A.'},
  {'id':'48', 'title':'Banco Indusval S.A.'},
  {'id':'49', 'title':'Banco Intercap S.A.'},
  {'id':'50', 'title':'Banco Investcred Unibanco S.A.'},
  {'id':'51', 'title':'Banco Itaú BBA S.A.'},
  {'id':'52', 'title':'Banco Itaú Holding Financeira S.A.'},
  {'id':'53', 'title':'Banco Itaú S.A.'},
  {'id':'54', 'title':'Banco ItaúBank S.A'},
  {'id':'55', 'title':'Banco J. P. Morgan S.A.'},
  {'id':'56', 'title':'Banco J. Safra S.A.'},
  {'id':'57', 'title':'Banco Luso Brasileiro S.A.'},
  {'id':'58', 'title':'Banco Mercantil de São Paulo S.A.'},
  {'id':'59', 'title':'Banco Mercantil do Brasil S.A.'},
  {'id':'60', 'title':'Banco Merrill Lynch de Investimentos S.A.'},
  {'id':'61', 'title':'Banco Nossa Caixa S.A.'},
  {'id':'62', 'title':'Banco Opportunity S.A.'},
  {'id':'63', 'title':'Banco Panamericano S.A.'},
  {'id':'64', 'title':'Banco Paulista S.A.'},
  {'id':'65', 'title':'Banco Pine S.A.'},
  {'id':'66', 'title':'Banco Prosper S.A.'},
  {'id':'67', 'title':'Banco Rabobank International Brasil S.A.'},
  {'id':'68', 'title':'Banco Rendimento S.A.'},
  {'id':'69', 'title':'Banco Rural Mais S.A.'},
  {'id':'70', 'title':'Banco Rural S.A.'},
  {'id':'71', 'title':'Banco Safra S.A.'},
  {'id':'72', 'title':'Banco Santander Banespa S.A.'},
  {'id':'73', 'title':'Banco Schahin S.A.'},
  {'id':'74', 'title':'Banco Simples S.A.'},
  {'id':'75', 'title':'Banco Société Générale Brasil S.A.'},
  {'id':'76', 'title':'Banco Sofisa S.A.'},
  {'id':'77', 'title':'Banco Sudameris Brasil S.A.'},
  {'id':'78', 'title':'Banco Sumitomo Mitsui Brasileiro S.A.'},
  {'id':'79', 'title':'Banco Triângulo S.A.'},
  {'id':'80', 'title':'Banco UBS Pactual S.A.'},
  {'id':'81', 'title':'Banco UBS S.A.'},
  {'id':'82', 'title':'Banco Único S.A.'},
  {'id':'83', 'title':'Banco Votorantim S.A.'},
  {'id':'84', 'title':'Banco VR S.A.'},
  {'id':'85', 'title':'Banco WestLB do Brasil S.A.'},
  {'id':'86', 'title':'BANESTES S.A. Banco do Estado do Espírito Santo'},
  {'id':'87', 'title':'Banif-Banco Internacional do Funchal (Brasil)S.A.'},
  {'id':'88', 'title':'Bankpar Banco Multiplo S.A.'},
  {'id':'89', 'title':'BB Banco Popular do Brasil S.A.'},
  {'id':'90', 'title':'BPN Brasil Banco Mútiplo S.A.'},
  {'id':'91', 'title':'BRB – Banco de Brasília S.A.'},
  {'id':'92', 'title':'Caixa Econômica Federal'},
  {'id':'93', 'title':'Citibank N.A.'},
  {'id':'94', 'title':'Deutsche Bank S.A. – Banco Alemão'},
  {'id':'95', 'title':'Dresdner Bank Brasil S.A. – Banco Múltiplo'},
  {'id':'96', 'title':'Dresdner Bank Lateinamerika Aktiengesellschaft'},
  {'id':'97', 'title':'Hipercard Banco Múltiplo S.A.'},
  {'id':'98', 'title':'HSBC Bank Brasil S.A. – Banco Múltiplo'},
  {'id':'99', 'title':'ING Bank N.V.'},
  {'id':'100', 'title':'JPMorgan Chase Bank'},
  {'id':'101', 'title':'Lemon Bank Banco Múltiplo S.A.'},
  {'id':'102', 'title':'UNIBANCO – União de Bancos Brasileiros S.A.'},
  {'id':'103', 'title':'Unicard Banco Múltiplo S.A.'},
  {'id':'104', 'title':'CARTEIRA'}
]

export default Bancos;
